import styled from 'styled-components';

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr;
  grid-column-gap: 6px;
  margin-bottom: 10px;
`;
